// extracted by mini-css-extract-plugin
var _1 = "ProfileFinishedWidgetRating-moduleProfileFinishedWidgetRating__CVOvt";
var _2 = "ProfileFinishedWidgetRating-moduleeditButton__YS4v2";
var _3 = "ProfileFinishedWidgetRating-modulelabel__R8UAm";
var _4 = "ProfileFinishedWidgetRating-modulerating__eJX_n";
export { _1 as "ProfileFinishedWidgetRating", _2 as "editButton", _3 as "label", _4 as "rating" }
